import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { TipoCondicion } from '../interfaces/tipo-condicion';
import { PermisoService } from './permiso.service';
import { Globals } from '../globals';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { GeneralService } from './general.service';

@Injectable()
export class InformePersonalizadoService {
  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private general: GeneralService,
    private permisoService: PermisoService
  ) { }

  getTablas(): Observable<any> {
    let model = {};
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFiltro/getTablas',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  getCampos(model): Observable<any> {
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFiltro/getCampos',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }
  filtrarInforme(model): Observable<any> {
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFiltro/filtrar',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }
  borrarInforme(model): Observable<any> {
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFiltro/eliminarFiltro',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  guardarFiltro(model): Observable<any> {
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFiltro/guardarFiltro',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  getFiltros(): Observable<any> {
    let model={};
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFiltro/getFiltros',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }
}